module.exports = __webpack_public_path__ + "assets/images/ert_2.11cac8cbef7d9cbbbac148ae0094a13f.png";